import React, {useState, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import useDropdownMenu from 'react-accessible-dropdown-menu-hook';
import onClickOutside from 'react-onclickoutside';
import {
  Switch,
  Route,
  useRouteMatch,
  useHistory,
} from 'react-router-dom';
import types from 'common/types';
import styles from './styles.module.scss';

const Popup = function ({
                          children,
                          onClickOutside,
                          customContainerClassName,
                          customDDContainerClassName,
                        }) {
  Popup.handleClickOutside = () => onClickOutside();

  const popupRef = useRef(null);
  const [origin, setOrigin] = useState('');

  useEffect(() => {
    //When popup bottom overflows the root, it shows above the button
    const rootHeight = getRootHeight();
    const popupBottomDistance = getPopupBottomDistance();

    if (popupBottomDistance > rootHeight) {
      setOrigin(styles.originBottom);
    } else {
      setOrigin(styles.originTop);
    }
  }, []);

  const getRootHeight = () => {
    const root = document.getElementById('root');
    return root.clientHeight;
  };

  const getPopupBottomDistance = () => {
    const distance = popupRef.current.getBoundingClientRect();
    return distance.bottom;
  };

  return (
    <div
      className={`${styles.menu} ${origin} ${customContainerClassName}`}
      role='menu'
      ref={popupRef}
    >
      {children}
    </div>
  );
};

const clickOutsideConfig = {
  handleClickOutside: () => Popup.handleClickOutside
};

const PopupWithClickOutside = onClickOutside(Popup, clickOutsideConfig);

const AbstractDropdownView = ({
                                triggerContent,
                                dropdownContent,
                                subPath = 'edit',
                                customContainerClassName,
                                customDDContainerClassName,
                                closeOnOutsideClick = true,
                              }) => {
  const {buttonProps, itemProps, isOpen, setIsOpen} = useDropdownMenu(dropdownContent.length);
  const {onClick, onKeyDown, ...triggerProps} = buttonProps;

  const {path} = useRouteMatch();
  const history = useHistory();
  const routePath = (path === '/') ? '' : path;

  const openDropdown = () => {
    history.push(`${routePath}/${subPath}`);
    setIsOpen(true);
  };

  const toggleDropdown = () => {
    if (isOpen) {
      closeDropdown();
    } else {
      openDropdown();
    }
  };

  const closeDropdown = () => {
    history.push(`${routePath}`);
    setIsOpen(false);
  };

  return (
    <div className={`${styles.ddContainer} ${customDDContainerClassName}`}>
      {triggerContent({toggleDropdown, triggerProps})}
      <Switch>
        <Route path={`${routePath}/${subPath}`}>
          {closeOnOutsideClick
            ? (
              <PopupWithClickOutside
                onClickOutside={closeDropdown}
                customContainerClassName={customContainerClassName}
              >
                {dropdownContent({closeDropdown, itemProps})}
              </PopupWithClickOutside>
            )
            : (
              <Popup
                onClickOutside={closeDropdown}
                customContainerClassName={customContainerClassName}
              >
                {dropdownContent({closeDropdown, itemProps})}
              </Popup>
            )
          }
        </Route>
      </Switch>
    </div>
  );

};

const {children} = types.children;

AbstractDropdownView.propTypes = {
  triggerContent: children,
  dropdownContent: children,
  subPath: PropTypes.string,
  overlayClassName: PropTypes.string,
  modalClassName: PropTypes.string,
  modalContainerClassName: PropTypes.string,
  closeOnOutsideClick: PropTypes.bool,
};

export default AbstractDropdownView;
